<template>
  <div class="form__card fx__box">
    <div class="card__head">
      <slot name="label">{{ title }}</slot>
    </div>
    <div class="card__content" :class="classes">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    col: {
      type: [Number, String],
      default: 3
    }
  },
  // inject: ['form'],
  methods: {},
  computed: {
    //标题样式
    titleStyles() {
      let style = {};
      // const test = this.col === 0 || this.col ? this.col : this.form.col
    },
    classes() {
      return `col-${this.col}`;
    }
  }
};
</script>
<style lang="scss" scoped>
.form__card {
  margin-bottom: 20px;
  padding:0!important;
}
.card__head {
  border-bottom: 1px solid #e8eaec;
  padding: 14px 16px;
  font-size: 14px;
  color: #17233d;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.card__content {
  display: flex;
  flex-wrap: wrap;
  padding: 16px;
  .card__item {
    width: 33%;
    padding: 0 10px;
    margin-bottom: 10px;
  }
}
</style>
<style lang="scss">
.card__content {
  &.col-1 {
    .card__item {
      width: 100%;
    }
  }
  &.col-2 {
    .card__item {
      width: 50%;
    }
  }
  &.col-3 {
    .card__item {
      width: 33.33%;
    }
  }
  &.col-4 {
    .card__item {
      width: 25%;
    }
  }
  &.col-5 {
    .card__item {
      width: 20%;
    }
  }
}
</style>